import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaStar, FaUsers } from 'react-icons/fa';

export default function SearchResultCard({ result, vehicleId }) {
  const qs = vehicleId ? `?vehicleId=${vehicleId}` : '';
  const href = result.catalogNodeId
    ? `/catalog/node/${result.catalogNodeId}${qs}`
    : '/search';

  return (
    <Link
      to={href}
      className="block rounded-xl border border-slate-200 bg-white p-4 hover:border-indigo-300 hover:shadow-sm transition"
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-base font-bold text-slate-900">{result.partName || result.partCategory}</h3>
          {result.subSystem && (
            <p className="text-xs text-slate-500 mt-0.5">{result.subSystem}</p>
          )}
          {result.vehicleHint && (
            <p className="text-xs text-slate-400 mt-1">{result.vehicleHint}</p>
          )}
          {result.conditionTier && result.conditionTier !== 'mixed' && (
            <span className="inline-block mt-2 text-[10px] font-bold uppercase px-2 py-0.5 rounded bg-slate-100 text-slate-600">
              {String(result.conditionTier).replace(/_/g, ' ')}
            </span>
          )}
        </div>
        <div className="text-right space-y-1 shrink-0">
          <p className="text-lg font-bold text-orange-600">{result.priceLabel || '—'}</p>
          <p className="inline-flex items-center gap-1 text-xs text-slate-600 justify-end">
            <FaUsers className="text-slate-400" />
            {result.sellerCount || 0} seller{(result.sellerCount || 0) === 1 ? '' : 's'}
          </p>
          {result.topSellerRating != null && (
            <p className="inline-flex items-center gap-1 text-xs text-slate-600 justify-end">
              <FaStar className="text-amber-400" />
              {Number(result.topSellerRating).toFixed(1)}
            </p>
          )}
          {result.distanceKm != null && (
            <p className="inline-flex items-center gap-1 text-xs text-slate-400 justify-end">
              <FaMapMarkerAlt />
              {result.distanceKm} km
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
